import { render } from "./MainCard.vue?vue&type=template&id=7eba8cdf&ts=true"
import script from "./MainCard.vue?vue&type=script&lang=ts"
export * from "./MainCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__